export const zh_CN: Record<string, any> = {
  pluginName: '快捷键',
};
